import { Environment } from '@nemuru-eng/js-api-client';
import { useEffect } from 'react';

import { ENV_ENV } from '@/config/envVars';
import { useScreen } from '@/hooks/useScreen';

const ZE_SNIPPET_ID = 'ze-snippet';

const applyZendeskPosition = (mdScreen: boolean) => {
  if (typeof window.zE !== 'function') return;

  window.zE('messenger:set', 'zIndex', 1100);
  window.zE('messenger:set', 'customization', {
    position: {
      side: mdScreen ? 'right' : 'left',
      offset: {
        web: { horizontal: 16, vertical: 16 },
        mobile: { horizontal: 20, vertical: 20 },
      },
    },
  });
};

export const useZendeskChat = () => {
  const { md } = useScreen();

  useEffect(() => {
    applyZendeskPosition(md);
  }, [md]);

  const setZendeskChat = () => {
    if (ENV_ENV === Environment.STG || ENV_ENV === Environment.DEV) {
      return;
    }

    if (process.env.NODE_ENV === 'development') {
      return;
    }

    if (document.getElementById(ZE_SNIPPET_ID)) {
      return;
    }

    const script = document.createElement('script');
    script.id = ZE_SNIPPET_ID;
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=94d7d18e-7d84-4d8a-a686-bc7a992716af';
    script.onload = () => {
      applyZendeskPosition(md);
    };
    script.onerror = () => {
      console.error('Error loading Zendesk script');
    };
    document.head.appendChild(script);
  };

  return { setZendeskChat };
};
